import EventEmitter from './eventEmiter';

export const showLoader = () => {
  EventEmitter.emit('apiLoaderEvent', true);
};
export const hideLoader = () => {
  EventEmitter.emit('apiLoaderEvent', false);
};
